<template>
  <div>
  <div class="teachCard">
    <div class="proTxt" v-show="defaultShow">
            <div>
              <img src="../../../../static/image/defaultpic.png" alt=""  height="140" />
            </div>
            <p :style="{'marginTop': '23px'}"> 未查询到符合条件记录</p>
    </div>
    <ul v-show="defaultHide">
      <li class="selfAdapt" v-for="(item,index) in tecahCardList">
        <span v-if="item.courseState === '3'" class="haveHind">进行中</span>
        <span v-if="item.courseState === '2'" class="haveHind noStart">未开始</span>
        <div class="imgPhoto" @click="jump(item.id)">
            <div class="btn"  style="width:40px;height:40px;position:absolute;top:-10px;right:-13px">
              <span v-if="isShow" :tabA="tabA" class="closeBtn" @click="cancel(tabA,item.id)">×</span>
            </div>
            <img v-if="item.courseImg !== undefined" class="defultImg" :src="item.courseImg" />
           <img v-else class="defultImg" src="../../../../static/image/default.png" />
        </div>
        <div class="belowTxt">
          <h3 @click="jump(item.id)">{{item.subject}}</h3>
          <div class="giveNum">
            <span class="iconfont icon-chakan"></span><i>{{item.lookNum}}</i>
            <span class="iconfont icon-pingjia"></span><i>{{item.evaluateNum}}</i>
            <span v-if="item.appreciateFlag==='0'" class="iconfont icon-dianzan"></span>
            <span v-else class="iconfont icon-yidianzan"></span>
            <i>{{item.goodNum}}</i>
            <i v-if="item.havaVide && item.havaVide !== '0'"  style="float: right;top: -7px;" class="icon-shexiangji"></i>
          </div>
          <div class="lastLine">
            <span class="studentName">{{item.teacherName}}</span>
            <span class="seeTime">{{item.onShelfTime}}</span>
          </div>
        </div>

      </li>
    </ul>
  </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  import {getDateDiff} from '@/common/js/time'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  export default {
    props: {
      active: {
        type: String,
        default: ''
      },
      tecahCardList: {
        type: Array,
        default: function () {
          return []
        }
      }
    },
    data() {
      return {
        isShow: false,
        defaultShow: false,
        defaultHide: true,
        tabA:'First'
      }
    },
    mounted() {
    },
    methods: {
      jump(val) {
        saveLocalStorage(val, 'Id')
        this.$emit('popShow',true)
      },
      cancel(tabA,val) {
        event.stopPropagation();
        if(tabA ==='third'){
          this.$confirm('是否取消收藏?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let params = {
              courseId: val,
              operateType: '0'
            }
            http.post('/studyCenter/collectCourse.json', params).then(res => {
              if (res.data.code === _.ERR_OK) {
                this.$emit('trigger')
              } else {
              }
            })
          }).catch(() => {

          });
        }else if( tabA==='fourth'){
          this.$confirm('是否要放弃当前学习？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let params = {
              courseId: val,
              operateType: '0'
            }
            http.post('/studyCenter/deteMyStudyCourse.json', params).then(res => {
              if (res.data.code === _.ERR_OK) {
                this.$emit('trigger')
              } else {
              }
            })
          }).catch(() => {

          });
        }
      },
    },
    created() {
      for (let item of this.tecahCardList) {

        item.onShelfTime = getDateDiff(item.onShelfTime)
      }
    },
    watch: {
      active(c){
        if(c==='third' || c==='fourth'){
          this.isShow = true
          this.tabA = c
        } else {
          this.isShow = false
        }
      },
      tecahCardList(e) {
        if(e.length!==0){
          this.defaultShow = false
          this.defaultHide = true
          for (let item of this.tecahCardList) {
            item.onShelfTime = getDateDiff(item.onShelfTime)
          }
          // console.log(this.tecahCardList)
        } else {
          this.defaultShow = true
          this.defaultHide = false
        }
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .teachCard
    margin: 10px auto 0
    overflow: hidden
    .proTxt
      text-align: center
      font-size: 16px
      position: relative
      top: 100px
      min-height: calc(100vh - 270px)
      overflow-y: auto
    ul
      overflow: hidden
      margin: auto
      min-height: calc(100vh - 295px)
      li
        float: left
        width: 225px
        height: 190px
        border-radius: 8px
        position: relative
        .closeBtn
          position: absolute
          top: -1px
          right: -1px
          width: 25px
          height: 25px
          background: #c5c1c1
          text-align: center
          line-height: 23px
          color: #fff
          font-size: 23px
          border-radius: 50%
          cursor: pointer
          z-index: 111
          display: none
        .haveHind
          display: block
          height: 25px
          width: 100%
          position: absolute
          top: 0
          left: 0
          background: url("../../../../static/image/hind.png") no-repeat
          color: #fff;
          line-height: 23px;
          font-size: 12px;
          padding-left: 5px
          border-radius: 8px 0 0 0
        .imgPhoto
          display flex
          widows 300px
          align-items center
          height: 110px
          overflow: hidden
          border-radius: 8px
        .imgPhoto:hover
          box-shadow: 10px 10px 5px #888888
          border-radius: 8px

          .defultImg
            margin-top: -5px
        .noStart
          background: url("../../../../static/image/nostart.png") no-repeat
        img
          width: 100%
          height:auto
          background: #fff
          border-radius: 8px
          cursor: pointer
        .belowTxt
          padding: 0 10px
          h3
            overflow: hidden
            white-space:nowrap
            text-overflow:ellipsis
            color: #000
            margin: 6px auto 8px
            line-height: 20px
            cursor: pointer
          h3:hover
            color: $color-green
          .giveNum
            i
             margin-right: 16px
             position: relative
             top: -1px
             left: 2px
             font-size: 13px
          .lastLine
            margin-top: 10px
            .studentName
              float: left
              color: #000
            .seeTime
              float: right
</style>



// WEBPACK FOOTER //
// teachCard.vue?0864a7fd